// document.addEventListener('DOMContentLoaded', function () {
//   const btn = document.querySelector('.desktop-nav-toggle');
//   const menu = document.querySelector('.vm-custom-tab-menu');

//   if (!btn || !menu) return;

//   btn.addEventListener('click', function () {
//     menu.classList.toggle('is-active');
//   });
// });


document.addEventListener('DOMContentLoaded', function () {
  const body = document.body;
  const menu = document.querySelector('.vm-custom-tab-menu');

  if (!menu) return;

  const observer = new MutationObserver(() => {
    if (body.classList.contains('main-nav-open')) {
      menu.classList.add('is-active');
    } else {
      menu.classList.remove('is-active');
    }
  });

  observer.observe(body, {
    attributes: true,
    attributeFilter: ['class']
  });

  
});


// document.addEventListener('DOMContentLoaded', function () {
//   const body = document.body;
//   const menu = document.querySelector('.vm-custom-tab-menu');
//   const closeBtn = document.querySelector('.vm-desktop-close');

//   if (!menu) return;

//   // Sync drawer with body class
//   const observer = new MutationObserver(() => {
//     if (body.classList.contains('main-nav-open')) {
//       menu.classList.add('is-active');
//     } else {
//       menu.classList.remove('is-active');
//     }
//   });

//   observer.observe(body, {
//     attributes: true,
//     attributeFilter: ['class']
//   });

//   // 👉 CLOSE BUTTON CLICK
//   if (closeBtn) {
//     closeBtn.addEventListener('click', function () {
//       body.classList.remove('main-nav-open');
//     });
//   }
// });



